import { jsx as _jsx } from "react/jsx-runtime";
import { Controller } from "react-hook-form";
import { DesktopDateTimePicker } from "@mui/x-date-pickers";
import { useTranslation } from "react-i18next";
export const DoraDateTimePicker = (props) => {
    const { controlField, id, onChange, value, label, minDateTime } = props;
    const { t } = useTranslation("components");
    return (_jsx(DesktopDateTimePicker, { slotProps: {
            field: { openPickerButtonPosition: "start" },
            inputAdornment: { position: "start" },
            openPickerButton: { tabIndex: -1 },
        }, displayWeekNumber: true, localeText: {
            calendarWeekNumberHeaderText: t("week"),
        }, label: label, ...(minDateTime && { minDateTime }), ...(id && { id }), ...(!controlField && { onChange, value }), ...controlField }));
};
export const UFDoraDateTimePicker = (props) => {
    const { name, control, ...rest } = props;
    return (_jsx(Controller, { name: name, control: control, render: ({ field }) => (_jsx(DoraDateTimePicker, { controlField: field, ...rest })) }));
};
//# sourceMappingURL=DoraDateTimePicker.js.map